import { useEffect, useState } from 'react';

interface CircularProgressProps {
  filling: number;
  size?: number;
  color?: string;
  title?: string;
}

const STROKE_WIDTH = 10;
const STYLES = {
  transition: 'all 0.5s',
};

export const CircularProgress = ({ size = 140, filling, color = '#009299', title = '' }: CircularProgressProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(filling);
  }, [filling]);

  const viewBox = `0 0 ${size} ${size}`;
  const radius = (size - STROKE_WIDTH) / 2;
  const halfSize = size / 2;
  const circumference = radius * Math.PI * 2;
  const dash = (progress * circumference) / 100;

  const moveToXIndicator = filling < 100 ? '65%' : '70%';

  return (
    <svg width={size} height={size} viewBox={viewBox}>
      <circle fill="none" stroke="#ccc" cx={halfSize} cy={halfSize} r={radius} strokeWidth={`${STROKE_WIDTH / 2}px`} />

      <circle
        fill="none"
        stroke={color}
        cx={halfSize}
        cy={halfSize}
        r={radius}
        strokeWidth={`${STROKE_WIDTH}px`}
        transform={`rotate(-90 ${halfSize} ${halfSize})`}
        strokeDasharray={[dash, circumference - dash] as unknown as number}
        strokeLinecap="round"
        style={STYLES}
      />

      <text fill="#212121" fontSize="12px" x="50%" y="30%" dy="20px" textAnchor="middle">
        {title}
      </text>

      <text fill="#212121" fontWeight="bold" fontSize="32px" x="45%" y="55%" dy="20px" textAnchor="middle">
        {filling}
      </text>

      <text fill="#212121" fontSize="14px" x={moveToXIndicator} y="68%" dy="2moveToX0px" textAnchor="middle">
        %
      </text>
    </svg>
  );
};
